module.exports = __webpack_public_path__ + "static/facebook-weather-b7901cf762fca808f21883bea11d1fe4.png";